<template>
  <div
    v-if="gateways.length > 1"
    class="space-y-2"
  >
    <p class="text-sm font-medium">
      درگاه پرداخت
    </p>
    <URadioGroup
      v-model="model"
      variant="card"
      :items="items"
    />
  </div>
</template>

<script setup lang="ts">
export type GatewayOption = { provider: string; label: string }

const model = defineModel<string>({ required: true })
const props = defineProps<{ gateways: GatewayOption[] }>()

const items = computed(() => props.gateways.map(gateway => ({
  label: gateway.label,
  value: gateway.provider,
})))
</script>
